export default __webpack_public_path__ + "static/media/banner_onayami_qa.cd740402.png";